// extracted by mini-css-extract-plugin
module.exports = {"ServiceCallStatusMappingPage":"ServiceCallStatusMappingPage_ServiceCallStatusMappingPage__3AbEp"};